// extracted by mini-css-extract-plugin
export default {"body":"CrmSalesManagerConsequencesModal_body__au0ZF","lead":"CrmSalesManagerConsequencesModal_lead__6RuDr","list":"CrmSalesManagerConsequencesModal_list__QC+pL"};